module.exports = __webpack_public_path__ + "static/media/newYear.b75dfd3b.svg";